import { Action } from '@ngrx/store';
import { DeleteAlertsCommand, ToggleStateCommand } from '../../commands/notifications.commands';


export const DELETE_NOTIFICATIONS = '[Notifications] DELETE_NOTIFICATIONS';
export const DELETE_NOTIFICATIONS_SUCCESS = '[Notifications] DELETE_NOTIFICATIONS_SUCCESS';
export const DELETE_NOTIFICATIONS_FAILED = '[Notifications] DELETE_NOTIFICATIONS_FAILED';

export const TOGGLE_STATE = '[Notifications] TOGGLE_STATE';
export const TOGGLE_STATE_SUCCESS = '[Notifications] TOGGLE_STATE_SUCCESS';
export const TOGGLE_STATE_FAILED = '[Notifications] TOGGLE_STATE_FAILED';

export class DeleteNotificationsAction implements Action {
  readonly type = DELETE_NOTIFICATIONS;
  constructor (public command: DeleteAlertsCommand, public smartGridSourceType) {
  }
}
export class DeleteNotificationsSuccessAction implements Action {
  readonly type = DELETE_NOTIFICATIONS_SUCCESS;
  constructor (public smartGridSourceType: string) {
  }
}
export class DeleteNotificationsFailAction implements Action {
  readonly type = DELETE_NOTIFICATIONS_FAILED;
  constructor (public payload: any) {
  }
}

export class ToggleStateAction implements Action {
  readonly type = TOGGLE_STATE;
  constructor (public command: ToggleStateCommand, public smartGridSourceType) {
  }
}
export class ToggleStateSuccessAction implements Action {
  readonly type = TOGGLE_STATE_SUCCESS;
  constructor (public smartGridSourceType: string) {
  }
}
export class ToggleStateFailAction implements Action {
  readonly type = TOGGLE_STATE_FAILED;
  constructor (public payload: any) {
  }
}

export type NotificationsActions = DeleteNotificationsAction
  | DeleteNotificationsSuccessAction
  | DeleteNotificationsFailAction
  | ToggleStateAction
  | ToggleStateSuccessAction
  | ToggleStateFailAction
  ;
